import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fetchStats = () => api.get("/stats").then((r) => r.data);
export const fetchTopics = () => api.get("/topics").then((r) => r.data);
export const fetchTopic = (slug) => api.get(`/topics/${slug}`).then((r) => r.data);
export const fetchIdeas = (params = {}) =>
  api.get("/ideas", { params }).then((r) => r.data);
export const fetchIdea = (id) => api.get(`/ideas/${id}`).then((r) => r.data);
export const fetchRuns = (params = {}) =>
  api.get("/runs", { params }).then((r) => r.data);
export const fetchRun = (id) => api.get(`/runs/${id}`).then((r) => r.data);
export const fetchSources = (params = {}) =>
  api.get("/sources", { params }).then((r) => r.data);
export const fetchEvents = () =>
  api.get("/retention/events").then((r) => r.data);
export const triggerRun = (payload) =>
  api.post("/runs/trigger", payload).then((r) => r.data);
export const triggerSweep = () =>
  api.post("/retention/sweep").then((r) => r.data);

// Phase 2 — Innovation
export const fetchInnovationItems = (params = {}) =>
  api.get("/innovation/items", { params }).then((r) => r.data);
export const fetchInnovationItem = (n) =>
  api.get(`/innovation/items/${n}`).then((r) => r.data);
export const fetchInnovationRuns = (params = {}) =>
  api.get("/innovation/runs", { params }).then((r) => r.data);
export const fetchInnovationRotations = (params = {}) =>
  api.get("/innovation/rotations", { params }).then((r) => r.data);
export const fetchInnovationStats = () =>
  api.get("/innovation/stats").then((r) => r.data);
export const triggerInnovation = (payload) =>
  api.post("/innovation/trigger", payload).then((r) => r.data);
export const triggerInnovationSweep = () =>
  api.post("/innovation/sweep").then((r) => r.data);

// Phase 14 — Personal Intelligence Layer (Watch List)
export const fetchWatchProfiles = () =>
  api.get("/watch/profiles").then((r) => r.data);
export const createWatchProfile = (payload) =>
  api.post("/watch/profiles", payload).then((r) => r.data);
export const updateWatchProfile = (id, payload) =>
  api.put(`/watch/profiles/${id}`, payload).then((r) => r.data);
export const deleteWatchProfile = (id) =>
  api.delete(`/watch/profiles/${id}`).then((r) => r.data);
export const fetchWatchHits = (id) =>
  api.get(`/watch/profiles/${id}/hits`).then((r) => r.data);
export const runWatchProfile = (id) =>
  api.post(`/watch/profiles/${id}/run`).then((r) => r.data);


// Billing
export const fetchPlans = () =>
  api.get("/billing/plans").then((r) => r.data);
export const startTrial = () =>
  api.post("/billing/trial/start").then((r) => r.data);

// Bot / Chat
export const sendChat = (payload) =>
  api.post("/bot/chat", payload).then((r) => r.data);
export const fetchSessions = () =>
  api.get("/bot/sessions").then((r) => r.data);
export const fetchSessionMessages = (id) =>
  api.get(`/bot/sessions/${id}/messages`).then((r) => r.data);
export const fetchPrompts = () =>
  api.get("/bot/prompts").then((r) => r.data);
export const createPrompt = (payload) =>
  api.post("/bot/prompts", payload).then((r) => r.data);
export const deletePrompt = (id) =>
  api.delete(`/bot/prompts/${id}`).then((r) => r.data);

// User library
export const fetchUserLib = (topic_slug) =>
  api
    .get("/user-library", { params: topic_slug ? { topic_slug } : {} })
    .then((r) => r.data);
export const createUserLibItem = (payload) =>
  api.post("/user-library", payload).then((r) => r.data);
export const deleteUserLibItem = (id) =>
  api.delete(`/user-library/${id}`).then((r) => r.data);

export function fmtDate(iso) {
  // Marketplace-compliant date-time: "Jan 3, 2021, 3:25 PM"
  // (3-letter month, no period · 12-hour clock)
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return iso;
  }
}

export function fmtDateOnly(iso) {
  // "Jan 3, 2021"
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      year: "numeric", month: "short", day: "numeric",
    });
  } catch {
    return iso;
  }
}

export function fmtTimeOnly(iso) {
  // "3:25 PM"
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleTimeString("en-US", {
      hour: "numeric", minute: "2-digit", hour12: true,
    });
  } catch {
    return iso;
  }
}

export function fmtRelative(iso) {
  if (!iso) return "—";
  const d = new Date(iso).getTime();
  const diff = (Date.now() - d) / 1000;
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}
